import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, X } from "lucide-react";

/**
 * tone: "ok" | "warn" | "bad"
 */
export default function StatusBanner({
    tone = "ok",
    title = "Tutto sotto controllo",
    subtitle = "Tutti i parametri sono nei limiti",
    time = "14:30",
    onDismiss,
    dismissLabel = "Azzera avviso",
}) {
    const cfg =
        tone === "bad"
            ? {
                bg: "from-rose-50 to-rose-100",
                border: "border-rose-200",
                text: "text-rose-700",
                iconWrap: "text-rose-600 bg-rose-100",
                Icon: XCircle,
            }
            : tone === "warn"
                ? {
                    bg: "from-amber-50 to-amber-100",
                    border: "border-amber-200",
                    text: "text-amber-700",
                    iconWrap: "text-amber-600 bg-amber-100",
                    Icon: AlertTriangle,
                }
                : {
                    bg: "from-emerald-50 to-emerald-100",
                    border: "border-emerald-200",
                    text: "text-emerald-700",
                    iconWrap: "text-emerald-600 bg-emerald-100",
                    Icon: CheckCircle2,
                };

    const Icon = cfg.Icon;

    return (
        <div
            className={[
                "rounded-2xl border bg-gradient-to-r p-5",
                "flex items-center justify-between gap-4",
                cfg.bg,
                cfg.border,
            ].join(" ")}
            style={{
                boxShadow:
                    "0px 20px 25px rgba(0,0,0,0.10), 0px 2px 4px rgba(0,0,0,0.10)",
            }}
        >
            <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-widest text-slate-500">
                    Status
                </div>
                <div className="mt-1 text-2xl font-semibold text-slate-900">
                    {title}
                </div>
                <div className="mt-1 text-sm text-slate-600">{subtitle}</div>
                {time ? (
                    <div className="mt-2 text-xs text-slate-500">{time}</div>
                ) : null}
            </div>

            <div className="flex shrink-0 items-center gap-2">
                {onDismiss ? (
                    <button
                        type="button"
                        onClick={onDismiss}
                        className="inline-flex items-center gap-1 rounded-xl border border-slate-300/80 bg-white/80 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-white"
                        title={dismissLabel}
                    >
                        <X size={15} />
                        <span className="hidden sm:inline">{dismissLabel}</span>
                    </button>
                ) : null}
                <div
                    className={[
                        "h-12 w-12 rounded-full grid place-items-center shrink-0",
                        cfg.iconWrap,
                    ].join(" ")}
                >
                    <Icon size={24} />
                </div>
            </div>
        </div>
    );
}
